import NotAllowed from "@/containers/StatusPages/NotAllowed";
import AccessControl from "@components/AccessControl";

const withRestriction = (
  WrappedComponent: React.ComponentType<unknown>,
  { level }: { level?: 0 | 1 | 2 }
) => {
  // Right now we'll just use this as a wrapper for AccessControl and return null.
  // In the future we might want to have a message here, or a 404 page.
  const WithRestriction = () => {
    return (
      <AccessControl level={level} fallback={<NotAllowed />}>
        <WrappedComponent />
      </AccessControl>
    );
  };
  return WithRestriction;
};

export default withRestriction;
